(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kes-help-center"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){const root=document.getElementById('kes-help');if(!root||root.dataset.ready)return;root.dataset.ready='true';const input=root.querySelector('#kh-search-input'),groups=[...root.querySelectorAll('.kh-topic')],status=root.querySelector('#kh-search-status');root.querySelector('.kh-search').hidden=false;function filter(){const terms=input.value.toLowerCase().trim().split(/\s+/).filter(Boolean);let count=0;groups.forEach(g=>{let shown=0;g.querySelectorAll('details').forEach(d=>{const text=(d.textContent+' '+d.dataset.keywords).toLowerCase();const match=terms.every(t=>text.includes(t));d.hidden=!match;d.open=Boolean(terms.length&&match);if(match){shown++;count++;}});g.hidden=!shown;});root.querySelector('#kh-no-results').hidden=count>0;status.textContent=terms.length?count+' matching answer'+(count===1?'':'s'):'';}input.addEventListener('input',filter);root.querySelector('#kh-clear').addEventListener('click',()=>{input.value='';filter();input.focus();});root.querySelectorAll('a[href^="#kh-"]').forEach(a=>a.addEventListener('click',()=>{input.value='';filter();const target=root.querySelector(a.getAttribute('href'));if(target&&target.tagName==='DETAILS')target.open=true;}));const initialTarget=location.hash&&root.querySelector(location.hash);if(initialTarget&&initialTarget.tagName==='DETAILS')initialTarget.open=true;const issue=root.querySelector('#kh-issue'),message=root.querySelector('#kh-message'),template=root.querySelector('#kh-template'),hint=root.querySelector('#kh-suggestion');if(!issue)return;const options={
'Order status':['Check <a href="https://account.kesmedik.com">your account</a> for order and tracking updates.',"I would like an update on my order.\nOrder date: \nWhat I need help with: "],
'Delivery issue':['Review your carrier tracking first. Include what the latest tracking update says.',"The tracking information says: \nThe delivery issue is: \nI have already checked: "],
'Change or cancel an order':['To request cancellation, <a href="https://account.kesmedik.com">open your order in your account</a> and select the cancellation option for eligible unfulfilled items. Requests need our review and do not automatically cancel or refund an order. Use this form for order changes or if the option is unavailable.',"I would like to change or cancel my order.\nThe change I need is: "],
'Return or refund':['You can <a href="https://account.kesmedik.com">request a return in your account</a>. Please wait for approval and a prepaid label before mailing items.',"I need help with a return or refund.\nProduct(s): \nDate received: \nReason for return or refund question: \nItem condition: "],
'Damaged or incorrect item':['Keep the packaging and any photos available. Tell us which item is affected.',"The affected product is: \nI received it on: \nThe damage or difference is: "],
'Subscription help':['<a href="https://account.kesmedik.com">Sign in and select Subscriptions</a> to skip, pause, cancel or update details.',"My subscription product is: \nI would like help with: \nMy next delivery date, if known: "],
'Product or ingredient question':['Include the exact product name so we can give you a relevant answer.',"Product name: \nMy question is: "],
'Account help':['Use the email from checkout to sign in. Never include a password or verification code.',"I am having trouble with: \nThe error message, if any, is: "],
'Privacy request':['Use this form for privacy questions, access or deletion requests, corrections, complaints or appeals. No account or order number is required. Please do not send identity documents or sensitive personal information.',"My privacy request concerns: \nThe request or question I have is: "],
'Something else':['Tell us a little about what you need and we will help you find the next step.',"I would like help with: "]};function update(){const data=options[issue.value];hint.hidden=!data;hint.innerHTML=data?data[0]:'';template.hidden=!data||Boolean(message.value.trim());}issue.addEventListener('change',update);message.addEventListener('input',update);template.addEventListener('click',()=>{if(!message.value.trim()&&options[issue.value]){message.value=options[issue.value][1];message.focus();update();}});update();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();
})();
